module.exports = __webpack_public_path__ + "img/2.b72e328c.jpg";